const Rectangle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
    >
      <path d="M0 0L13.4165 8.27361L4.33509e-07 16.5472L0 0Z" fill="white" />
    </svg>
  );
};

export default Rectangle;
